exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-icon[data-v-113d246d]{margin-right:3px;font-size:18px;position:relative;top:2px;color:#4eaffa}.text-content[data-v-113d246d]{text-align:center;padding:30px 0 50px;font-size:13px;color:#666;word-wrap:break-word}.flex-row[data-v-113d246d]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
